// extracted by mini-css-extract-plugin
export var linkText = "_pa-0";